import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal-list.component';
import { ModalUnitComponent } from './modal-unit/modal-unit.component';
import { I18nModule } from '@spartacus/core';
import { ModalIconsModule } from './utilities/icons/icons.module';

@NgModule({
  declarations: [ModalComponent, ModalUnitComponent],
  imports: [CommonModule, I18nModule, ModalIconsModule],
  exports: [ModalComponent],
})
export class ModalListModule {}
